import notUndefinedOrNull from './notUndefinedOrNull';
export default function isDefined(value) {
    return notUndefinedOrNull(value);
}
